import React from "react";

import { localizer } from '../../../Translator'

import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { Button } from  "@material-ui/core";
import { Grid } from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { Backdrop, CircularProgress } from "@material-ui/core"
import Chip from '@material-ui/core/Chip'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import FeedbackShipmentSummary from '../../inbox/sections/FeedbackShipmentSummary'

import { TableRowStyled, TableCellStyled } from '../../common/TableStyled.js'

import { SnackbarCustom } from "../../Utilities/SnackbarCustom";
import DateCustom from "../../Utilities/DateCustom";
import { MultiShipmentImageViewer } from "../../Utilities/MultiShipmentImageViewer"
import Roles from "../../Utilities/Roles"
import StateCodes from "../../Utilities/StateCodes.js";

import InboxCli from "../../../sdk/InboxCli";
import OutboxCli from "../../../sdk/OutboxCli";
import ProductCli from "../../../sdk/ProductCli";


const CANCEL = 'CANCEL'
const CANCEL_DELETE= 'CANCEL_DELETE'
const DELETE = 'DELETE'


/**
 * Class component that represents a shipment 
 * as a row into the drafts list table.
 * Implemented as a React.Component to preserve the historical behavior of this row.
 */
export class ShipmentRow extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      open: false,
      openShipmentModal: false,
      openDraftModal: false,
      pageBase64Error: null,
      uploadDraftError: null,
      openResendModal: false,
                
      // Shipment object which feedback belong to
      shipment: {},
      shipmentFeedbacks: [],

      states: [],
      certs: [],
      proofs: [],
      reports: [],
      documents: [],
      stampedCopies: [],

      // Indicates if shipment summary of the feedback is open or closed
      openModal: false,

      //viewer
      documentpages: [],
      pagenumber: 1,

      //Modal deleteDraft
      removeDraft: false,
      onlyCancel: false,
      buttonDisabled: true,
      buttonCancelName: localizer.Accept,
      buttonNotDo: localizer.Cancel,

      checked: true,
      shipmentsCodesSelected: [],

      isLoading: false,

      //assigned codes
      trackings: [],
      trackingsDispatches: [],
      trackingMain: {},

      // String errors to display in case of service calls go wrong
      message: null,
      severity: "error",

      // These flag indicates if page options menu must be opened or closed
      optionsMenu: null,
      openMenu: false,
    }
  }

  componentDidMount() {
    const trackingModel = this.buildTrackingModel(this.props.trackings)
    const checked = this.props.shipmentsCodesSelected ? this.props.shipmentsCodesSelected.includes(this.props.shipment.shipmentCode) : false
    
    this.setState({
      shipment: this.props.shipment, checked: checked,
      shipmentsCodesSelected: this.props.shipmentsCodesSelected,
      trackingMain: trackingModel.trackingMain, trackingsDispatches: trackingModel.trackingsDispatches,
      trackings: trackingModel.trackings,
      shipmentFeedbacks: this.props.feedbacks,
      states: this.props.states || []
    })
    
  }

  componentDidUpdate(prevProps, prevState) {
    const shipmentChanged = prevProps.shipment !== this.props.shipment
    const trackingsChanged = prevProps.trackings !== this.props.trackings
    const feedbacksChanged = prevProps.feedbacks !== this.props.feedbacks
    const statesChanged = prevProps.states !== this.props.states
    const selectedChanged = prevProps.shipmentsCodesSelected !== this.props.shipmentsCodesSelected

    if (!shipmentChanged && !trackingsChanged && !feedbacksChanged && !statesChanged && !selectedChanged) return

    const nextState = {}
    if (shipmentChanged) {
      nextState.shipment = this.props.shipment
    }

    if (trackingsChanged) {
      const trackingModel = this.buildTrackingModel(this.props.trackings)
      nextState.trackingMain = trackingModel.trackingMain
      nextState.trackingsDispatches = trackingModel.trackingsDispatches
      nextState.trackings = trackingModel.trackings
    }

    if (feedbacksChanged) {
      nextState.shipmentFeedbacks = this.props.feedbacks
    }

    if (statesChanged) {
      nextState.states = this.props.states || []
    }

    if (selectedChanged || shipmentChanged) {
      nextState.checked = this.props.shipmentsCodesSelected
        ? this.props.shipmentsCodesSelected.includes(this.props.shipment.shipmentCode)
        : false
    }

    if (Object.keys(nextState).length === 0) return

    this.setState(nextState)
      
  }

  /**
   * Builds a normalized tracking view model for the row from the received trackings prop.
   * - Clones and sorts tracking entries by assigned time (oldest to newest).
   * - Exposes the first tracking as the main one.
   * - Exposes the remaining entries as re-dispatch trackings.
   */
  buildTrackingModel = (trackingsProp) => {
    const source = Array.isArray(trackingsProp) ? [...trackingsProp] : []
    source.sort(this.sortByDate("assignedTime"))

    const trackingMain = source.length > 0 ? source[0] : {}
    const trackingsDispatches = source.length > 1 ? source.slice(1) : []

    return {
      trackings: source,
      trackingMain,
      trackingsDispatches
    }
  }

  /**
    * Gets feedbacks information of the shipment given 
    */
  getFeedbacksOfShipment = () => {
    InboxCli.GetFeedbackOfShipment(this.state.shipment.shipmentCode, true, true, true, true, true).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ message: null, shipmentFeedbacks: data })
      }
    })
  }

  /**
   * Gets certs information of shipment to display it in the summary
   */
  getCertsInfo = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_CERT).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetCerts(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')) })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ certs: filtered, message: null })
      }
    })
  }

  /**
   * Gets proofs information of shipment to display
   */
  getProofsInfo = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_PROOF).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetProofs(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ proofs: filtered, message: null })
      }
    })
  }

  /**
   * Gets documents information of shipment to display
   */
  getDocuments = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_DOCUMENT).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetDocuments(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ documents: filtered, message: null })
      }
    })
  }

  /**
   * Gets stamped copies information of shipment to display
   */
  getStampedCopies = () => {
    let retunsIds = this.state.shipmentFeedbacks ? this.state.shipmentFeedbacks.filter(f => f.returnType === InboxCli.RETURN_STAGE_STAMPED_COPY).map(f => f.returnId) : []
    if (retunsIds.length === 0) return

    InboxCli.GetStampedCopy(retunsIds).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ message: data.substring(data.indexOf(' ')), severity: "error" })
      } else {
        let filtered = data.filter(d => d !== null)
        if (filtered) filtered.sort(this.sortByDate("timestamp"))
        this.setState({ stampedCopies: filtered, message: null })
      }
    })
  }


  handleOpenShipmentModal = () => {
    this.setState({ openShipmentModal: true })
  }

  handleCloseShipmentModal = () => {
    this.setState({ openShipmentModal: false, buttonDisabled: true })
  }

  handleOpenDraftModal = () => {
    this.setState({ documentpages: this.state.shipment.pages, openDraftModal: true })
  }

  handleCloseDraftModal = () => {
    this.setState({ openDraftModal: false })
  }

  /**
   * Removes or Cancel a shipment when the user press its 'accept ' button in dialog with options 
   */
  deleteShipment = (event) => {
    let name = event.currentTarget.getAttribute('name')
    let onlyCancel = this.state.onlyCancel
    let removeDraft = this.state.removeDraft

    /* For these buttons there aren't options and therefore we get their corresponding form are taken */
    switch (name.toUpperCase()) {
      case 'CANCEL':
        removeDraft = false;
        onlyCancel = true;
        break;
      case 'DELETESHIPEMENTCANCELLED':
        removeDraft = true;
        onlyCancel = false;
        break;
      default:
        onlyCancel = this.state.onlyCancel
        removeDraft = this.state.removeDraft
        break;
    }

    this.setState({ removeDraft: removeDraft, onlyCancel: onlyCancel, buttonDisabled: false },
      () => {
        this.props.removeOrCancelShipment(this.state.shipment, this.state.onlyCancel, this.state.removeDraft)
        this.setState({ openShipmentModal: false })
      })
  }
  
  /**
   * Set the state open / collapsed of Collapse elements for expandable rows.
   */
  setOpen = () => {
    this.setState({ open: !this.state.open },
      () => {
        if (this.state.open) {
          this.getCertsInfo()
          this.getProofsInfo()
          this.getDocuments()
          this.getStampedCopies()
        }
      })
  }
  
  /**
   * Set the state open of shipment summary dialog.
  */
  handleOpenModal = () => { this.setState({ openModal: true }) }

  /**
   * Set the state closed of shipment summary dialog.
  */
  handleCloseModal = () => { this.setState({ openModal: false }) }

  handleInkChange = (event) => {
    /*if not event is because user cancel a shipment consolidated*/
    let action = event.target.value
    let removeDraft = false;
    let onlyCancel = false;
    let buttonCancelName = localizer.Cancel
    let buttonNotDo = localizer.NoCancel
    
    switch (action.toUpperCase()) {
      case 'REMOVEDRAFT':
        removeDraft = true
        onlyCancel = false
        buttonCancelName = localizer.Delete
        buttonNotDo = localizer.NoDelete
        break;
      case 'CANCEL':
        removeDraft = false
        onlyCancel = true
        buttonCancelName = localizer.Cancel
        buttonNotDo = localizer.NoCancel
        break;
      default:
        break;
    }
    this.setState({ removeDraft: removeDraft, onlyCancel: onlyCancel, buttonDisabled: false, buttonCancelName: buttonCancelName, buttonNotDo: buttonNotDo })
  }

  setBorderStyleByState = () => {
    let border = "solid 5px #219A4A"

    if (!this.state.shipment) return border
    
    if (this.state.shipment.cancelTime) {
      border = "solid 5px #F90606"
      return border
    }

    if (!this.state.shipment.emissionTime) {
      border = "solid 5px #ff8c00"
      return border
    }

    if (new Date(this.state.shipment.emissionTime) > Date.now()) {
      border = "solid 5px #ABABAB"
      return border
    }

    return border
  }

  /*return to snackbar*/
  handleonClose = () => { this.setState({ message: null }) }
  
  /**
   * Checkbox row onChange event. It calls the parent component function to add or remove feedback
   * from feedbacks selected list
   * @param {*} event 
   */
  handleChangeCheck = () => {
    const { addOrRemoveSelectedShipment } = this.props
    this.setState({ checked: !this.state.checked },
      () => {
       
        var shipmentCode = this.state.shipment.shipmentCode
        var option = this.state.checked ? "CHECKED" : "UNCHECKED"

        addOrRemoveSelectedShipment(shipmentCode, option)
      })
  }

  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  mountDestinationAddressWho = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let who = this.state.shipment.destinationAddress.who
    return who
  }

  /**
   * sort json by date atribute asc
   */
  sortByDate(prop) {
    return function (a, b) {
      if (a && b) {
        var a2 = Date.parse(a[prop].substring(0, 23) + a[prop].substring(26));
        var b2 = Date.parse(b[prop].substring(0, 23) + b[prop].substring(26));
        return new Date(a2).getTime() - new Date(b2).getTime()
      }
    }
  }
  
  /**
  * check if the editing button is enabled 
  */
  isEditable = () => {
    if (this.state.shipment.cancelTime !== null || this.state.shipment.dequeuedTime !== null || this.state.shipment.cancelRequestedTime !== null || this.props.currentUser.toLowerCase() !== this.state.shipment.ownerUser.toLowerCase()) {
      return false
    }
    
    let burofaxRegistered = this.state.trackings.filter(t => t.processingType === "TELEGRAF")
    if (burofaxRegistered.length !== 0) return false

    return true
  }

  /**
  * check if the cancel/delete button is enabled 
  */
  isCancelable = () => {
    //let burofaxRegistered = this.state.trackings.filter(t => t.processingType === "TELEGRAF")
    //if (burofaxRegistered.length !== 0) return false
    
    if ((this.state.shipment.cancelTime !== null && this.state.shipment.dequeuedTime !== null) || this.state.shipment.cancelRequestedTime !== null || this.props.currentUser.toLowerCase() !== this.state.shipment.ownerUser.toLowerCase()) {
      return false
    }
    return true
  }

  // Check is shipment can be resent
  isResendable = () => {
    if (!this.props.currentUser) return false
    if (!this.state.shipment) return false
    if (!this.state.shipment.ownerUser) return false

    return this.props.currentUser.toLowerCase() === this.state.shipment.ownerUser.toLowerCase()
  }
  
  /**
   * operation that can be done
   */
  operationCanDo = () => {
    if (!this.isCancelable()) return

    //burofax
    //let burofaxRegistered = this.state.trackings ? this.state.trackings.filter(t => t.processingType === "TELEGRAF" ).length !== 0 : false
    //if (burofaxRegistered) return CANCEL

    //shipments
    if (this.state.trackings && this.state.trackings.length > 1) {
      return CANCEL
    }

    if ((this.state.shipment.cancelTime !== null && this.state.shipment.dequeuedTime === null) || (DateCustom.greaterThan(this.state.shipment.emissionTime, Date.now()))) {
      return DELETE
    }
    if (this.state.shipment.emissionTime !== null && DateCustom.lowerThan(this.state.shipment.emissionTime, Date.now()) && this.state.shipment.dequeuedTime === null && this.state.shipment.cancelTime === null) {
      return CANCEL_DELETE
    }
    if (this.state.shipment.emissionTime !== null && DateCustom.lowerThan(this.state.shipment.emissionTime, Date.now()) && this.state.shipment.dequeuedTime !== null && this.state.shipment.cancelTime === null) {
      return CANCEL
    }
  }
  
  /**
   * get url to logistic operator
   */
  getUrlOperator = (tracking) => {
    if (!tracking) return ''
    let products = ["PQ", "PK", "NB", "CD", ...ProductCli.SIDI_PRODUCT_CODE];
    let codTracking = tracking.codeValue
    let initTracking = codTracking && codTracking.slice(0, 2);
    const url = products.includes(initTracking) ?
      'https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number=' + codTracking : ''
    return url
  }

  getProductDescription = () => {
    let description = ""
    this.props.products && this.state.shipment.features && this.props.products.forEach(product => {
      if (product.productCode === this.state.shipment.features.productCode) {
        description = product.description
        return
      }
    })
    return description
  }

  /**
   * download the file associated to feedback
  */
  downloadFeedbackFile = (event) => {
    let returnId = event.currentTarget.getAttribute('name')
    if (!returnId) return

    this.setState({ isLoading: true })
    InboxCli.DownloadFeedbackFile(returnId).then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')), severity: "error" })
      else this.setState({ message: null })
      this.setState({ isLoading: false })
    })
  }

  /**
   * Download original document of shipment
   */
  downloadDocument = () => {
    if (this.props.role === Roles.ROLE_USER.Name) {
      this.downloadShipmentDocument()
      return
    }

    if (this.props.role === Roles.ROLE_ADMIN.Name || this.props.role === Roles.ROLE_SUPERVISOR.Name) {
      this.downloadShipmentDocumentOfBillable()
      return
    }
  }

  downloadShipmentDocument = () => {
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocument(this.state.shipment.shipmentCode).then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')) })
      else this.setState({ message: null })
      this.setState({ isLoading: false })
    })
  }

  downloadShipmentDocumentOfBillable = () => {
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocumentOfBillable(this.state.shipment.shipmentCode).then((error) => {
      if (error) this.setState({ message: error.substring(error.indexOf(' ')) })
      else this.setState({ message: null })
      this.setState({ isLoading: false })
    })
  }
  
  bytesToBestMagnitude = (len) => {
    let sizes = ["B", "KB", "MB", "GB", "TB"]
    let order = 0;
    while (len >= 1024 && order < sizes.length - 1) {
      order++;
      len = len / 1024;
    }
   
    let newLen = (Math.round(len * 100) / 100).toFixed(1) + " " + sizes[order]
    return newLen
  }

  /* Action menu handler */
  handleClickOptionsMenu = (event) => { this.setState({ optionsMenu: event.currentTarget, openMenu: true }) }
  handleOpenOptionsMenu = () => { this.setState({ openMenu: true }) }
  handleCloseOptionsMenu = () => { this.setState({ openMenu: false }) }

  handleOpenResendModal = () => { this.setState({ openResendModal: true }) }
  handleCloseResendModal = () => { this.setState({ openResendModal: false }) }

  /* getDetailsState = () => {
    let stateCodeDetails = this.state.states && this.state.states.length > 0 ? this.state.states[this.state.states.length - 1] : null;
    if (!stateCodeDetails) return '';

    // Deserializar stateData si es necesario
    let stateData = stateCodeDetails.stateData;
    if (typeof stateData === 'string') {
      try {
        stateData = JSON.parse(stateData);
      } catch (error) {
        console.error("Error parsing stateData:", error);
        return '';
      }
    }

    let description = stateData ? stateData.Description : null;
    return description;
  } */

  render() {
    
    let isEditable = this.isEditable()
    let isCancelable = this.isCancelable()
    let isResendable = this.isResendable()
    let operationCanDone = this.operationCanDo()
    let url = this.getUrlOperator(this.state.trackingMain)

    let stateCode = (this.state.states && this.state.states.length > 0) ? StateCodes.CODES.find(c => c.stateCode === this.state.states[this.state.states.length - 1].stateCode) : null
    let stateName = stateCode ? stateCode.name : null
    let status = this.state.shipment ? this.state.shipment.cancelTime !== null ? localizer.Cancelled : (this.state.shipment.emissionTime !== null && new Date(this.state.shipment.emissionTime) > Date.now()) ? localizer.InboxProgrammed : stateName !== null ? stateName : localizer.InboxSent : ""
    let labelEmissionTime = this.state.shipment ? (this.state.shipment.emissionTime !== null && new Date(this.state.shipment.emissionTime) > Date.now()) ? localizer.InboxDateProgrammed : localizer.InboxDateEmission : null
    let trackingNA = this.state.shipment && this.state.shipment.dequeuedTime && !this.state.trackingMain ? "N/A" : null

    let isFinalState = this.state.shipment.cancelTime !== null ? true : stateCode ? stateCode.end : false
    let showCancelResquested = this.state.shipment && this.state.shipment.cancelRequestedTime && !isFinalState ? true : false
    //let stateCodeDetails = this.getDetailsState()
   
    return (
      <React.Fragment>
        <TableRowStyled>
          <TableCellStyled className="text-align-center">
            <Checkbox
              //defaultChecked
              checked={this.state.checked !== undefined ? this.state.checked : false}
              onChange={this.handleChangeCheck}
              name={this.props.shipment.shipmentId}
              color="primary"
              icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
              checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
            />
          </TableCellStyled>
          
          <TableCellStyled className="text-align-center" style={{ borderLeft: this.setBorderStyleByState() }}>
            <Tooltip className="typography-generic" title={<Typography className="typography-generic">{this.state.open ? localizer.ExpandLess : localizer.ExpandMore}</Typography>}>
              <IconButton aria-label="expand row" size="small" onClick={this.setOpen}>
                {this.state.open ? <i className="fa-solid fa-angle-up font-size-20"></i> : <i className="fa-solid fa-angle-down font-size-20"></i>}
              </IconButton>
            </Tooltip>
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content font-weight-bold" onClick={this.setOpen} align="center">{this.state.shipment ? this.state.shipment.shipmentCode : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" onClick={this.setOpen} align="center">{this.getProductDescription()}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" onClick={this.setOpen} align="center">{(this.state.shipment && this.state.shipment.ownerUser && this.props.currentUser.toLowerCase() !== this.state.shipment.ownerUser.toLowerCase()) ? this.state.shipment.ownerUser.toLowerCase() : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content font-weight-bold" onClick={this.setOpen} align="center">
            {this.state.shipment && this.state.shipment.features && this.state.shipment.features.reference &&
              <Tooltip className="typography-generic" title={<Typography className="typography-generic">{this.state.shipment.features.reference}</Typography>}>
                <span>{this.state.shipment.features.reference.length > 20 ? this.state.shipment.features.reference.substring(0, 15) + "..." : this.state.shipment.features.reference}</span>
              </Tooltip>
            }
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen} >{this.state.shipment ? this.state.shipment.cancelTime !== null ? localizer.InboxNotSent : this.state.shipment.emissionTime !== null ? DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime) : localizer.InboxNotSent : ""}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen} style={{ wordBreak: "break-all" }}>{this.mountDestinationAddressWho()}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center" onClick={this.setOpen}>
            {status}<br />{showCancelResquested &&
              <Chip className="cancelRequested-tag" icon={<i className="fa-solid fa-triangle-exclamation font-size-12 color-proof-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxStateCNR}</Typography>} />}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">
            <Tooltip title={<Typography className="typography-generic">{localizer.GoToTracking}</Typography>}>
              <IconButton className="button-generic icon-button" aria-label="Location">
                {url ? <a href={url} target="_blank" rel="noreferrer"><i className="fa-solid fa-location-dot"></i></a>
                  : <i className="fa-solid fa-location-dot"></i>}
              </IconButton>
            </Tooltip>
          </TableCellStyled>
          
          {/*  <TableCellStyled align="center">
            <Tooltip title={<Typography className="typography-generic">{localizer.ViewDocument}</Typography>}>
              <IconButton className="button-generic icon-button" aria-label="Visibility" onClick={this.handleOpenDraftModal}>
                <i className="fa-solid fa-eye"></i>
              </IconButton>
            </Tooltip>
          </TableCellStyled> */}

          {/* <TableCellStyled align="center">
            {!isEditable ?
              <Tooltip title={<Typography className="typography-generic">{localizer.CannotBeEditedShipment}</Typography>}>
                <div>
                  <IconButton className="button-generic icon-button" disabled={true} aria-label="edit"><i className="fa-solid fa-pencil"></i></IconButton>
                </div>
              </Tooltip> :
              
              <Tooltip title={<Typography className="typography-generic">{localizer.EditShipment}</Typography>}>
                <Link to={"/shipment?shipmentCode=" + this.state.shipment.shipmentCode}>
                  <IconButton className="button-generic icon-button" aria-label="edit"><i className="fa-solid fa-pencil"></i></IconButton>
                </Link>
              </Tooltip>
            }
          </TableCellStyled> */}

          {/* Its canceled and consolidated or re-dispatch*/}
          {/*  <TableCellStyled align="center">
            {!isCancelable ?
              <Tooltip title={<Typography className="typography-generic">{localizer.CannotBeDeletedShipment}</Typography>}>
                <div>
                  <IconButton className="button-generic icon-button" disabled={true} >
                    <i className="fa-solid fa-circle-xmark"></i>
                  </IconButton>
                </div>
              </Tooltip> :
              <Tooltip title={<Typography className="typography-generic">{localizer.CancelDeleteShipment}</Typography>}>
                <IconButton className="button-generic icon-button" onClick={this.handleOpenShipmentModal}>
                  <i className="fa-solid fa-circle-xmark"></i>
                </IconButton>
              </Tooltip>}
          </TableCellStyled> */}
          
          {/* Action Menu */}
          <TableCellStyled align="center">
            <IconButton style={{ width: "20px", height: "20px" }} aria-label="more" aria-controls="shipment-options" aria-haspopup="true" onClick={this.handleClickOptionsMenu}>
              <i className="fa-solid fa-ellipsis-vertical"></i>
            </IconButton>
            <Menu id="page-options"
              anchorEl={this.state.optionsMenu}
              open={this.state.openMenu}
              onClose={this.handleCloseOptionsMenu}
              keepMounted
            >
              <MenuItem key="view-option" onClick={() => { this.handleOpenDraftModal(); this.handleCloseOptionsMenu() }}>
                <Typography className="typography-generic small"><i className="fa-solid fa-eye mr-5"></i>{localizer.ViewDocument}</Typography>
              </MenuItem>

              {!isEditable ?
                <MenuItem key="edit-option" onClick={() => { this.setState({ message: localizer.CannotBeEditedShipment }) }}>
                  <Typography className="typography-generic small" >
                    <i className="fa-solid fa-pencil mr-5"></i>
                    {localizer.EditShipment}
                  </Typography>
                </MenuItem>
                :
                <MenuItem key="edit-option" onClick={() => { window.location.href = '/shipment?shipmentCode=' + this.state.shipment.shipmentCode }}>
                  <Typography className="typography-generic small" >
                    <i className="fa-solid fa-pencil mr-5"></i>
                    {localizer.EditShipment}
                  </Typography>
                </MenuItem>
              }

              {!isResendable ?
                <MenuItem key="resend-option" onClick={() => { this.setState({ message: localizer.CannotBeResent }) }}>
                  <Typography className="typography-generic small">
                    <i className="fa-solid fa-circle-arrow-right mr-5"></i>
                    {localizer.Resend}
                  </Typography>
                </MenuItem>
                :
                <MenuItem key="resend-option" onClick={() => { this.handleOpenResendModal(); this.handleCloseOptionsMenu() }}>
                  <Typography className="typography-generic small">
                    <i className="fa-solid fa-circle-arrow-right mr-5"></i>
                    {localizer.Resend}
                  </Typography>
                </MenuItem>
              }
              
              {!isCancelable ?
                <MenuItem key="cancel-option" onClick={() => { this.setState({ message: localizer.CannotBeDeletedShipment }) }}>
                  <Typography className="typography-generic small" >
                    <i className="fa-solid fa-circle-xmark mr-5"></i>
                    {localizer.CancelShipment}
                  </Typography>
                </MenuItem>
                :
                <MenuItem key="cancel-option" onClick={() => { this.handleOpenShipmentModal(); this.handleCloseOptionsMenu() }}>
                  <Typography className="typography-generic small" >
                    <i className="fa-solid fa-circle-xmark mr-5"></i>
                    {localizer.CancelShipment}
                  </Typography>
                </MenuItem>
              }
              
            </Menu>
          </TableCellStyled>

        </TableRowStyled>
        {/* Collapse row */}
        <TableRow>
          <TableCellStyled style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
            <Collapse in={this.state.open} timeout="auto" unmountOnExit>
              <Grid container direction="row" style={{ borderBottom: "1px solid #DADADA" }}>
                <Grid item md={4} style={{ borderRight: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxChronology}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  {this.state.shipment &&
                    <Grid container item md={12}>
                      <Grid item md={5}><Typography className="typography-generic small">{DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography></Grid>
                      <Grid item md={7}><Typography className="typography-generic small bigweight">{labelEmissionTime}</Typography></Grid>
                    </Grid>
                  }
                  {this.state.states && this.state.states.slice(-3).map((state, index) => {
                    let stateCode = StateCodes.CODES.find(c => c.stateCode === state.stateCode)
                    let stateName = stateCode ? stateCode.name : null
                    return (
                      <Grid container item md={12} key={state.returnId}>
                        <Grid item md={5}><Typography className="typography-generic small pb-0 pt-0">{DateCustom.convertUTCToLocalTime(state.timestamp)}</Typography></Grid>
                        <Grid item md={7}>
                          <Typography className="typography-generic small bigweight pb-0 pt-0">
                            {stateName}
                          </Typography>
                          <Typography className="typography-generic xsmall  pb-0 pt-0">
                            {state.stateData.Details ? state.stateData.Description + " - " + state.stateData.Details : state.stateData.Description}
                          </Typography>
                        </Grid>
                      </Grid>
                    )
                  }
                  )}
                  {this.state.trackingMain &&
                    <Grid container direction="row" className="mt-15">
                      <Grid item md={12} >
                        <Grid item md={12}>
                          <Typography className="typography-generic bigweight secondary"> {localizer.Tracking}: </Typography></Grid>
                      </Grid>
                      <Grid container item md={12}>
                        <Grid item md={5}><Typography className="typography-generic small pb-0 pt-0">{DateCustom.convertUTCToLocalTime(this.state.trackingMain.assignedTime)}</Typography></Grid>
                        <Grid item md={7}><Typography className="typography-generic small bigweight  pb-0 pt-0"><a href={url} className="link-hover" target="_blank" rel="noreferrer">{this.state.trackingMain.codeValue}</a></Typography></Grid>
                      </Grid>
                    </Grid>
  
                  }
                  {trackingNA !== null &&
                    <Grid container direction="row" className="mt-15">
                      <Grid item md={12} >
                        <Typography className="typography-generic bigweight secondary"> {localizer.Tracking}: {trackingNA}</Typography></Grid>
                      
                    </Grid>
  
                  }
                  {this.state.trackingsDispatches && this.state.trackingsDispatches.length !== 0 &&
                    <Grid container item md={12} className="mt-15">
                      <Grid item md={12}>
                        <Typography className="typography-generic bigweight secondary"> {localizer.ReDispatches}: </Typography>
                        <hr className="hr-custom" />
                      </Grid>
                      {this.state.trackingsDispatches && this.state.trackingsDispatches.map(t => {
                        let url = this.getUrlOperator(t)
                        return (
                          <Grid container item md={12} key={t.returnId || t.codeValue || t.assignedTime}>
                            <Grid item md={5}><Typography className="typography-generic small pb-0 pt-0">{DateCustom.convertUTCToLocalTime(t.assignedTime)}</Typography></Grid>
                            <Grid item md={7}><Typography className="typography-generic small bigweight  pb-0 pt-0"><a href={url} className="link-hover" target="_blank" rel="noreferrer">{t.codeValue}</a></Typography></Grid>
                          </Grid>

                        )
                      })
                      }
                      {/* 
                    <Button className="button-generic primary width-auto ml-20 m-10" variant="outlined" startIcon={<LocationOnIcon />}>
                      {localizer.PostalOperator}
                    </Button> */}
                    </Grid>
                  }
                </Grid>
                <Grid item md={4} style={{ borderRight: "1px solid #DADADA" }}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxShipmentInfo}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12}>
                    <Grid item md={4}><Typography className="typography-generic small bigweight">{localizer.InboxShipmentType}:</Typography></Grid>
                    <Grid item md={8}><Typography className="typography-generic small">{this.getProductDescription()}</Typography></Grid>
                  </Grid>
                  <Grid container item md={12}>
                    <Grid item md={4}><Typography className="typography-generic small bigweight">{localizer.InboxDestination}:</Typography></Grid>
                    <Grid item md={8}>
                      <Typography className="typography-generic small white-space-pre" style={{ overflowX: "auto" }} >{this.mountDestinationAddress()}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={4}>
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary">{localizer.InboxDocuments}</Typography>
                  </Grid>
                  <hr className="hr-custom"></hr>
                  <Grid container item md={12}>
                    <Grid item md={9}>
                      <Typography className="typography-generic small textinline bigweight link-hover" onClick={this.downloadDocument}>{localizer.InboxDocumentOriginal}</Typography>
                      <Typography className="typography-generic xsmall m-0 pt-0">{DateCustom.convertUTCToLocalTime(this.state.shipment.emissionTime)}</Typography>
                    </Grid>
                    <Grid item md={3} className="text-align-right mt-5" >
                      <Chip className="document-tag ml-5" icon={<i className="fa-solid fa-file-lines font-size-12 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxDocument}</Typography>} />
                    </Grid>
                  </Grid>
                  {this.state.documents && this.state.documents.map((document) => {
                    let size = document !== null ? this.bytesToBestMagnitude(document.documentSize) : 0
                    return (
                      <Grid container item md={12} key={document.returnId} direction="row">
                        <Grid item md={9} className="m-0 pt-0">
                          <Typography name={document.returnId} className="typography-generic small textinline bigweight link-hover" onClick={this.downloadFeedbackFile}>{document.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(document.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip className="document-tag ml-5" icon={<i className="fa-solid fa-file-lines font-size-12 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxDocument}</Typography>} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.stampedCopies && this.state.stampedCopies.map((stampedCopy) => {
                    let size = stampedCopy !== null ? this.bytesToBestMagnitude(stampedCopy.documentSize) : 0
                    return (
                      <Grid container item md={12} key={stampedCopy.returnId} direction="row">
                        <Grid item md={9} className="m-0 pt-0">
                          <Typography name={stampedCopy.returnId} className="typography-generic small textinline bigweight link-hover" onClick={this.downloadFeedbackFile}>{stampedCopy.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(stampedCopy.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>

                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip className="document-tag ml-5" icon={<i className="fa-solid fa-stamp font-size-12 color-document-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxStampedCopy}</Typography>} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.proofs && this.state.proofs.map((proof) => {
                    let size = proof !== null ? this.bytesToBestMagnitude(proof.documentSize) : 0
                    return (
                      <Grid container item md={12} key={proof.returnId}>
                        <Grid item md={9}>
                          <Typography className="typography-generic small textinline bigweight link-hover" name={proof.returnId} onClick={this.downloadFeedbackFile}>{proof.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(proof.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip className="proof-tag ml-5" icon={<i className="fa-solid fa-file-lines font-size-12 color-proof-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxProof}</Typography>} name={proof.returnId} />
                        </Grid>
                      </Grid>
                    )
                  })}
                  {this.state.certs && this.state.certs.map((cert, index) => {
                    let size = cert !== null ? this.bytesToBestMagnitude(cert.documentSize) : 0
                    return (
                      <Grid container item md={12} key={cert.returnId}>
                        <Grid item md={9}>
                          <Typography className="typography-generic small textinline bigweight link-hover" name={cert.returnId} onClick={this.downloadFeedbackFile}>{cert.documentFileName}</Typography>
                          <Typography className="typography-generic xsmall m-0 pt-0"><strong>{localizer.Date}</strong>:&nbsp;{DateCustom.convertUTCToLocalTime(cert.timestamp)}&nbsp; &nbsp; <strong>{localizer.Size}</strong>:&nbsp;{size} </Typography>
                        </Grid>
                        <Grid item md={3} className="text-align-right mt-5">
                          <Chip className="cert-tag ml-5" icon={<i className="fa-solid fa-certificate font-size-12 color-cert-icon" />} variant="outlined" label={<Typography className="typography-generic xsmall font-weight-bold">{localizer.InboxCert}</Typography>} name={cert.returnId} />
                        </Grid>
                      </Grid>
                    )
                  })}
                </Grid>
              </Grid>
              <Grid container direction="row" style={{ padding: "5px" }}>
                <Grid item md={11} style={{ maxHeight: 50 }}></Grid>
                <Grid item md={1} style={{ maxHeight: 50 }}>
                  <Button className="button-generic card font-size-12" variant="outlined" size="small" onClick={this.handleOpenModal}>{localizer.InboxViewAll}</Button>
                </Grid>

              </Grid>
            </Collapse>
          </TableCellStyled>
        </TableRow>
        {/* if openModal= true */}
        {this.state.openModal &&
          <FeedbackShipmentSummary shipmentCode={this.state.shipment.shipmentCode} openModal={this.state.openModal} trackingMain={this.state.trackingMain} trackingsDispatches={this.state.trackingsDispatches} handleCloseModal={this.handleCloseModal}></FeedbackShipmentSummary>
        }

        <Dialog
          open={this.state.openShipmentModal}
          onClose={this.handleCloseShipmentModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          {/* If the shipment has already been consolidated, the option you have is:
              • Mark it as canceled (an internal email will arrive to try to get out of the process)
            If the shipment has not yet been consolidated, the options you have are:
              • Mark the shipment as canceled (will not consolidate but is still listed in canceled status)
              • Delete the shipment keeping the draft document (in case you want to use it in a future shipment)
              • Delete the submission and also delete the draft document
            If the shipment has been cancelled, the options you have are:            
              • Delete the shipment keeping the draft document (in case you want to use it in a future shipment)
              • Delete the submission and also delete the draft document
            */}
          
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseShipmentModal}></i>
            {/* title according to state */}
            {/* cancelled */}
            {operationCanDone === DELETE ?
              <Typography className="typography-generic dialog-title">{localizer.DeleteShipment}</Typography> :
              operationCanDone === CANCEL_DELETE ?
                <Typography className="typography-generic dialog-title">{localizer.DeleteOrCancelShipment}</Typography> :
                <Typography className="typography-generic dialog-title">{localizer.CancelShipment}</Typography>
            }
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4}>
              <Grid container item md={12} direction="row" spacing={2}>
                {/* content according to state */}
                {operationCanDone === DELETE ?
                  <Grid>
                    <Typography className="typography-generic">{localizer.TheShipment}<b>{this.state.shipment.shipmentCode}</b> {localizer.DeleteShipmentConfirmation}</Typography>
                    <Typography className="typography-generic">{localizer.AreYouSure}</Typography>
                  </Grid>
                  :
                  // sent and not yet consolidated AND NOT MULTITRACKING
                  operationCanDone === CANCEL_DELETE ?
                    <Grid>
                      <Typography className="typography-generic font-size-20">{localizer.TheShipment}<b>{this.state.shipment.shipmentCode}</b>{localizer.CancelAndDeleteShipmentConfirmation}</Typography>
                      <RadioGroup className="ml-40 mt-10" aria-label="position" name="position" defaultValue="" onChange={this.handleInkChange}>
                        <FormControlLabel value="cancel" control={<Radio color="primary" />} label={<Typography className="typography-generic" variant="caption">{localizer.OnlyCancel}</Typography>} labelPlacement="end" />
                        <FormControlLabel value="removeDraft" control={<Radio color="primary" />} label={<Typography className="typography-generic" variant="caption">{localizer.DeleteShipmentAndDraft}</Typography>} labelPlacement="end" />
                      </RadioGroup>
                    </Grid>
                    :
                    //sent and yet consolidated OR MULTITRACKING == ONLY CANCEL
                    //(this.state.shipment.emissionTime !== null && DateCustom.lowerThan(this.state.shipment.emissionTime, Date.now()) && this.state.shipment.dequeuedTime !== null && this.state.shipment.cancelTime === null) &&
                    <Typography className="typography-generic">{localizer.TheShipment}<b>{this.state.shipment.shipmentCode}</b>{localizer.CancelShipmentConfirmation}</Typography>
                }
              </Grid>

              {/* buttons according to status if consolidte, buttom accept is  disabled={false}.. if not, when user do click */}
              {/* cancelled */}
              {operationCanDone === DELETE ?
                <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                  <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseShipmentModal}>{localizer.NoDelete}</Button>
                  <Button name="DELETESHIPEMENTCANCELLED" disabled={false} className="button-generic dialog-delete" variant="contained" onClick={this.deleteShipment}>{localizer.Delete}</Button>
                </Grid>
                :
                // sent and not yet consolidated and not cancelled
                operationCanDone === CANCEL_DELETE ?
                  <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                    <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseShipmentModal}>{this.state.buttonNotDo}</Button>
                    <Button name="DELETEORCANCEL" disabled={this.state.buttonDisabled} className="button-generic dialog-delete" variant="contained" onClick={this.deleteShipment}>{this.state.buttonCancelName}</Button>
                  </Grid> :
                  <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                    <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseShipmentModal}>{localizer.NoCancel}</Button>
                    <Button name="CANCEL" disabled={false} className="button-generic dialog-delete" variant="contained" onClick={this.deleteShipment}>{localizer.Cancel}</Button>
                  </Grid>
              }
              
            </Grid>
          </DialogContent>
        </Dialog>
        
        {/* View document dialog */}
        <Dialog
          open={this.state.openDraftModal}
          onClose={this.handleCloseDraftModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
        >
          <DialogTitle id="alert-dialog-title">
            <Typography className="typography-generic dialog-title">{localizer.PDFPreview}</Typography>
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseDraftModal}></i>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <MultiShipmentImageViewer
              shipmentId={this.state.shipment.shipmentId}
              documentpages={this.state.documentpages}
              pagenumber={this.state.pagenumber}
              viewerWidth={500}
              viewerHeight={600}
            />
          </DialogContent>
        </Dialog>

        {/* Resend dialog */}
        <Dialog
          open={this.state.openResendModal}
          onClose={this.handleCloseResendModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="sm"
        >
          <DialogTitle id="alert-dialog-title">
            <Typography className="typography-generic dialog-title">{localizer.ResendShipment}</Typography>
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.handleCloseResendModal}></i>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container item md={12}>
              <Typography className="typography-generic">{localizer.ResendConfirm}</Typography>
            </Grid>
            <Grid container item md={12} className="mt-10" direction="row" spacing={2} justify="flex-end">
              <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.handleCloseResendModal}>{localizer.Cancel}</Button>
              <Button className="button-generic dialog-primary" variant="contained" onClick={() => { window.location.href = '/shipment?shipmentCode=' + this.state.shipment.shipmentCode + "&resend=true" }}>{localizer.Accept}</Button>
            </Grid>
          </DialogContent>
        </Dialog>

        {/* General error. */}
        <SnackbarCustom message={this.state.message} severity={this.state.severity} handleonClose={this.handleonClose} />
    
        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }

      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/outbox/sections/ShipmentRow.js